import { IStore } from '../../index'

export function getCalendarId(state: IStore): number {
  return state.bookingCalendar.calendarId
}

export function getOnbordingModalOpen(state: IStore): boolean {
  return state.bookingCalendar.onboarding
}

export function getSurveyModalOpen(state: IStore): boolean {
  return state.bookingCalendar.survey
}